import { useContext, useMemo } from 'react';

import { AuthenticationContext } from '../providers/authentication-provider';

export const useAuthentication = () => {
  const context = useContext(AuthenticationContext);

  if (!context) {
    throw new Error(
      'useAuthentication hook must be used within AuthenticationContext',
    );
  }

  const value = useMemo(
    () => ({
      isLoading: context.status !== 'complete',
      token: context.token,
      organisationId: context.organisationId,
    }),
    [context.organisationId, context.status, context.token],
  );

  return value;
};
